import React, { useEffect, useState } from "react";
import style from "./Task.module.css";

function TaskModal({ editTask, ModalHandler, setTasksHandler }) {
  const [task, setTask] = useState("");
  const [note, setNote] = useState("");
  console.log(editTask.editaTask);

  useEffect(() => {
    if (editTask.editTaskId) {
      setTask(editTask.editaTask);
      setNote(editTask.editNote);
    }
  }, [editTask.editTaskId]);

  // if (editTask.editaTask) {
  //   setTask(editTask.editaTask);
  //   setNote(editTask.editNote);
  // }

  const saveTaskHandler = (e) => {
    e.preventDefault();
    console.log(`Task - ${task}` + `Note - ${note}`);
    if (!task) return;
    setTasksHandler(task, note, editTask.editTaskId);
    ModalHandler();
  };

  const cancelTaskHandler = () => {
    setTask("");
    setNote("");
    ModalHandler();
  };

  return (
    <div>
      <div className={style.modal}>
        <input
          type="text"
          className={style.taskHeading}
          placeholder="Write your task here !!"
          value={task}
          onChange={(e) => setTask(e.target.value)}
        />
        <div className={style.noteContainer}>
          <textarea
            onChange={(e) => setNote(e.target.value)}
            value={note}
            rows="3"
            placeholder="Some Notes..."
          ></textarea>
        </div>

        <div className={style.taskButtonContainer}>
          <button
            onClick={cancelTaskHandler}
            className={style.taskButtonCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={saveTaskHandler}
            className={style.taskButtonSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default TaskModal;
